const SAVED_LIST_COMPONENT = document.querySelector('.saved--items');
//tabs id
let historyData = document.querySelector('[data-id="searchHistory"]');
let devData = document.querySelector('[data-id="savedDev"]');
let propData = document.querySelector('[data-id="savedProp"]');
let phaseData = document.querySelector('[data-id="savedPhase"]');
let savedSrcData = document.querySelector('[data-id="savedSearch"]');

if (SAVED_LIST_COMPONENT) {
    let tabContent = SAVED_LIST_COMPONENT.querySelector('.tab-content-wrapper');
    let getDevsData = async function(status) {
        loadMsg.innerText = document.querySelector('.loading-message').value;
        loadMsg.classList = 'loader-title';
        SAVED_LIST_COMPONENT.appendChild(loadWrap);
        const DEV_TYPE = document.querySelector('.type-development').value;
        let response;
        response = await fetch(`${APIPrefix.get()}/search_api/savedfavoriteproperties?type=${DEV_TYPE}`);
        if (response.ok) {
            SAVED_LIST_COMPONENT.removeChild(loadWrap);
            let data = await response.json();
            if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
              } else {
                return data;
              }
        } else {
            tabContent.style.display = 'none';
            loadWrap.removeChild(loadCirc);
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    //saved search api
    let getSavedSearchData = async function(status) {
        loadMsg.innerText = document.querySelector('.loading-message').value;
        loadMsg.classList = 'loader-title';
        SAVED_LIST_COMPONENT.appendChild(loadWrap);
        let response;
        let SEARCH_URL = document.querySelector('#searchUrl').value;
        let TYPE_SAVED_SEARCH = document.querySelector('.type-saved-search').value;
        response = await fetch(`${APIPrefix.get()}/api/searchhistory?searchPageUrl=${SEARCH_URL}&type=${TYPE_SAVED_SEARCH}`);
        if (response.ok) {
            SAVED_LIST_COMPONENT.removeChild(loadWrap);
            let data = await response.json();
            if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
              } else {
                return data;
              }
          } else {
            tabContent.style.display = 'none';
            loadWrap.removeChild(loadCirc);
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };
    //saved search + history
    let getSavedHistoryData = async function(status) {
        let response;
        let SEARCH_URL = document.querySelector('#searchUrl').value;
        let TYPE_SAVED_HISTORY = document.querySelector('.type-search-history').value;
        response = await fetch(`${APIPrefix.get()}/api/searchhistory?searchPageUrl=${SEARCH_URL}&type=${TYPE_SAVED_HISTORY}`);
        if (response.ok) {
            let data = await response.json();
            if (data.status === "401") {
              APIUtils.redirectUserToSigninPage();
            } else {
              return data;
            }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    //get for saved property api
    async function getSavedPropertyData(status) {
        const PROP_TYPE = document.querySelector('.type-property').value;
        let response;
        response = await fetch(`${APIPrefix.get()}/search_api/savedfavoriteproperties?type=${PROP_TYPE}`);
        if (response.ok) {
            let data = await response.json();
            if (data.status === "401") {
              APIUtils.redirectUserToSigninPage();
            } else {
              return data;
            }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    //get for saved phase api
    let getSavedPhaseData = async function(status) {
        const PHASE_TYPE = document.querySelector('.type-phase').value;
        let response;
        response = await fetch(`${APIPrefix.get()}/search_api/savedfavoriteproperties?type=${PHASE_TYPE}`);
        if (response.ok) {
            let data = await response.json();
            if (data.status === "401") {
              APIUtils.redirectUserToSigninPage();
            } else {
              return data;
            }
        } else {
            tabContent.style.display = 'none';
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    if (devData) {
        getDevsData()
            .then((data) => {
                createTable('savedDev', data);
            })
            .catch((e) => console.log(e));
    }

    if (historyData) {
        getSavedHistoryData()
            .then((data) => {
                createTable('searchHistory', data);
            })
            .catch((e) => console.log(e));
    }

    if (propData) {
        getSavedPropertyData()
            .then((data) => {
                createTable('savedProp', data);
            })
            .catch((e) => console.log(e));
    }

    if (phaseData) {
        getSavedPhaseData()
            .then((data) => {
                createTable('savedPhase', data);
            })
            .catch((e) => console.log(e));
    }

    if (savedSrcData) {
        getSavedSearchData().then((data) => {
            createTable('savedSearch', data);
        }).catch((e) => console.log(e));
    }

    function createTable(type, data) {
        const HEADINGS = data.data.headings;
        const ITEMS = data.data.items;
        const CONFIGURATION = data.data.configuration;
        const TABLE_WRAPPER = document.querySelector('div[data-id="' + type + '"] .table-wrapper');
        const TABLE = document.createElement('table');
        TABLE.setAttribute('class', 'pagination');
        TABLE_WRAPPER.appendChild(TABLE);
        for (const field in data.data) {
            const THEAD = document.createElement('thead');
            const TABLE_ROW = document.createElement('tr');
            THEAD.appendChild(TABLE_ROW);
            const TBODY = document.createElement('tbody');
            if (field == 'headings') {
                for (const child in HEADINGS) {
                    const HEADER_CELL = document.createElement('th');
                    TABLE_ROW.appendChild(HEADER_CELL);
                    HEADER_CELL.innerText = HEADINGS[child];
                    TABLE.appendChild(THEAD);
                }
            } else if (field == 'items') {
                for (const child in ITEMS) {
                    const TABLE_ROW = document.createElement('tr');
                    const TABLE_ACTIONS = document.createElement('td');
                    TABLE_ACTIONS.setAttribute('class', 'cell--actions');
                    let item = ITEMS[child].fields;
                    let actions = ITEMS[child].actions;
                    let configuration = ITEMS[child].configuration;
                    for (const row in item) {
                        const TABLE_DATA = document.createElement('td');

                        TABLE_ROW.appendChild(TABLE_DATA);
                        if (row == 'developmentphone' || row == 'phasephoneno') {
                            let phoneNumberCollapsed = item[row].phoneNumber.replace(/\s/g, '');

                            const PHONE = `<span class="call-tracking-number-rich-text">
                              <a href="tel:${phoneNumberCollapsed}">${item[row].phoneNumber}</a>
                             </span>`;
                            TABLE_DATA.innerHTML = PHONE;
                        } else if (row == 'savedsearchesalerts') {
                            const CREATE_BTN = document.createElement('a');
                            CREATE_BTN.classList = 'button--action button-icon--left button--feedback create-alert-cta';
                            CREATE_BTN.setAttribute('title', item[row].alertActionData.name);
                            CREATE_BTN.setAttribute('tabindex', 0);
                            CREATE_BTN.innerText = item[row].alertActionData.name;
                            const ALERT_ICON = document.createElement('span');
                            if (item[row].isAlert === false) {
                                ALERT_ICON.classList = 'icon-bell button-icon';
                            } else {
                                ALERT_ICON.classList = 'icon-delete button-icon';
                            }
                            CREATE_BTN.appendChild(ALERT_ICON);
                            TABLE_DATA.appendChild(CREATE_BTN);
                            CREATE_BTN.addEventListener('keyup', (event) => {
                                if (event.keyCode === 13) {
                                    event.preventDefault();
                                    CREATE_BTN.click();
                                }
                            });

                            CREATE_BTN.addEventListener('click', () => {
                                async function createAlert(status) {
                                    let response;
                                    response = await fetch(`${item[row].alertActionData.url}`, {
                                        method: 'POST',
                                        headers: {
                                            'Content-type': 'application/json',
                                        },
                                    });
                                    if (!response.ok) {
                                        throw new Error(`HTTP error! status: ${response.status}`);
                                    }
                                    let data = await response.json();
                                    return data;
                                }
                                createAlert().then((data) => {
                                    if (data.status === 'success') {
                                        createFeedbackMsg(true, data);
                                        showFeedbackMsg();
                                        setTimeout(function() {
                                            window.location.reload();
                                            return false;
                                        }, 2000);
                                    } else if (data.status === '401') {
                                        window.location.href = `${item[row].alertActionData.timedouturl}`;
                                    }
                                }).catch((e) => console.log(e));
                            });
                        } else {
                            TABLE_DATA.innerText = item[row];
                        }

                        TBODY.appendChild(TABLE_ROW);
                        TABLE.appendChild(TBODY);
                    }

                    if (historyData) {
                        if (actions.view) {
                            const VIEW = `<a href="${actions.view.url}"  title="${actions.view.name}" class="button--action button-icon--left button--feedback"><i class="icon-view button-icon"></i>${actions.view.name}</a>`;
                            TABLE_ACTIONS.innerHTML += VIEW;
                        }
                    } else if (actions.view.name.length === 0) {
                        const VIEW = ``;
                        TABLE_ACTIONS.innerHTML = VIEW;
                    } else {
                        if (actions.view) {
                            const VIEW = `<a href="${actions.view.url}"  title="${actions.view.name}" class="button--action button-icon--left button--feedback"><i class="icon-view button-icon"></i>${actions.view.name}</a>`;
                            TABLE_ACTIONS.innerHTML = VIEW;
                        }
                    }
                    if (actions.save) {
                        const SAVE_BTN = document.createElement('a');
                        SAVE_BTN.classList = 'button--action button-icon--left button--feedback save-search-btn';
                        SAVE_BTN.innerText = actions.save.name;
                        SAVE_BTN.setAttribute('title', actions.save.name);
                        SAVE_BTN.setAttribute('tabindex', 0);
                        const SAVE_ICON = document.createElement('span');
                        SAVE_ICON.classList = 'icon-star button-icon';
                        SAVE_BTN.appendChild(SAVE_ICON);
                        TABLE_ACTIONS.appendChild(SAVE_BTN);
                        TABLE_ACTIONS.classList.add('saved-wrapper');

                        if (configuration.isSaved === true) {
                            SAVE_BTN.classList.add('disabled');
                            SAVE_BTN.disabled = true;
                            SAVE_BTN.tabIndex = -1;
                        }

                        SAVE_BTN.addEventListener('keyup', (event) => {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                                SAVE_BTN.click();
                            }
                        });

                        SAVE_BTN.addEventListener('click', () => {
                            async function saveSearchItem(status) {
                                let response;
                                response = await fetch(`${actions.save.url}`, {
                                    method: 'POST',
                                });
                                if (!response.ok) {
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                let data = await response.json();
                                return data;
                            }

                            saveSearchItem().then((data) => {
                                if (data.status === 'success') {
                                    createFeedbackMsg(true, data);
                                    showFeedbackMsg();
                                    setTimeout(function() {
                                        window.location.reload();
                                        return false;
                                    }, 2000);
                                }
                            }).catch((e) => console.log(e));
                        });
                    }

                    if (actions.delete) {
                        const DELETE_BTN = document.createElement('a');
                        DELETE_BTN.classList = 'button--action button-icon--left button--feedback';
                        DELETE_BTN.textContent = actions.delete.name;
                        const DEL_ICON = document.createElement('span');
                        DEL_ICON.classList = 'icon-delete button-icon';
                        DEL_ICON.style.pointerEvents = 'none';
                        DELETE_BTN.setAttribute('title', actions.delete.name);
                        DELETE_BTN.setAttribute('tabindex', 0);
                        DELETE_BTN.appendChild(DEL_ICON);
                        TABLE_ACTIONS.appendChild(DELETE_BTN);
                        DELETE_BTN.addEventListener('keyup', (event) => {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                                DELETE_BTN.click();
                            }
                        });
                        if (savedSrcData) {
                            DELETE_BTN.addEventListener('click', (e) => {
                                async function deleteSavedSearch(status) {
                                    let response;
                                    response = await fetch(`${actions.delete.url}`, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-type': 'application/json',
                                        },
                                    });
                                    if (!response.ok) {
                                        throw new Error(`HTTP error! status: ${response.status}`);
                                    }
                                    let data = await response.json();
                                    return data;
                                }
                                deleteSavedSearch().then((data) => {
                                    if (data.status === 'success') {
                                        createFeedbackMsg(true, data);
                                        showFeedbackMsg();
                                        setTimeout(function() {
                                            window.location.reload();
                                            return false;
                                        }, 2000);
                                    } else if (data.status === '401') {
                                        window.location.href = `${actions.delete.timedouturl}`;
                                    }
                                }).catch((e) => console.log(e));
                            });
                        } else {
                            DELETE_BTN.addEventListener('click', (e) => {
                                async function deleteDev(status) {
                                    let response;
                                    response = await fetch(`${actions.delete.url}`, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-type': 'application/json',
                                        },
                                    });
                                    if (!response.ok) {
                                        throw new Error(`HTTP error! status: ${response.status}`);
                                    }
                                    let data = await response.json();
                                    return data;
                                }

                                deleteDev().then((data) => {
                                    createFeedbackMsg(true, data);
                                    showFeedbackMsg();
                                    if (data.status === 'success') {
                                        let activeParentIdProp = e.target.closest('.active');
                                        e.target.parentElement.parentElement.remove();
                                        let tables = activeParentIdProp.querySelector('.pagination');
                                        let tbody = tables.querySelector('tbody').nextElementSibling;
                                        let feedbackMsgParent = tables.parentElement;
                                        let tabID = activeParentIdProp.getAttribute('data-id');
                                        let ERROR_MSG = document.createElement('span');
                                        let errorValue;
                                        if (tabID === 'savedDev' && !tbody.innerHTML) {
                                            errorValue = document.querySelector('.no-dev-item').value;
                                            ERROR_MSG.innerText = errorValue;
                                        }
                                        if (tabID === 'savedProp' && !tbody.innerHTML) {
                                            errorValue = document.querySelector('.no-prop-item').value;
                                            ERROR_MSG.innerText = errorValue;
                                        }
                                        if (tabID === 'savedPhase' && !tbody.innerHTML) {
                                            errorValue = document.querySelector('.no-phase-item').value;
                                            ERROR_MSG.innerText = errorValue;
                                        }
                                        if (tabID === 'savedSearch' && !tbody.innerHTML) {
                                            errorValue = document.querySelector('#noSavedSearches').value;
                                            const CLEAR_BTN_ALL = document.querySelector('.clear-all--button');
                                            CLEAR_BTN_ALL.classList.add('disabled');
                                            ERROR_MSG.innerText = errorValue;
                                        }
                                        ERROR_MSG.setAttribute('class', 'no-items');
                                        feedbackMsgParent.appendChild(ERROR_MSG);
                                    } else if (data.status === '401') {
                                        APIUtils.redirectUserToSigninPage();
                                    }
                                }).catch((e) => console.log(e));
                            });
                        }
                    }

                    TABLE_ROW.appendChild(TABLE_ACTIONS);
                }
            }
            const SAVED_TABLES = document.querySelectorAll('.pagination');
            SAVED_TABLES.forEach((tabls) => {
                let dataTable = new DataTable(tabls, {
                    perPageSelect: false,
                    searchable: false,
                    firstLast: true,
                    lastText: '',
                    prevText: '',
                    fixedHeight: false,
                    fixedColumns: false,
                    nextText: '',
                    firstText: '',
                    sortable: false,
                    labels: {
                        info: '',
                    },
                });
            });
        }

        if (ITEMS === undefined || ITEMS.length == 0) {
            let ERROR_MSG = document.createElement('span');
            ERROR_MSG.innerText = CONFIGURATION.headerTemplateMessage;
            ERROR_MSG.setAttribute('class', 'no-items');
            TABLE_WRAPPER.appendChild(ERROR_MSG);
        }
    }

    let clearAllBtn = document.querySelectorAll('.clear-all--button');
    if (clearAllBtn) {
        clearAllBtn.forEach((clearCta) => {
            let clearParent = clearCta.parentElement;
            clearCta.addEventListener('click', () => {
                async function clearAllData(status) {
                    let activeClearTabParameter = clearParent.parentElement.getAttribute('data-id');
                    let response;
                    response = await fetch(`${APIPrefix.get()}/api/searchhistory?type=${activeClearTabParameter}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-type': 'application/json',
                        },
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    let data = await response.json();
                    return data;
                }

                clearAllData().then((data) => {
                    createFeedbackMsg(true, data);
                    showFeedbackMsg();
                    if (data.status === 'success') {
                        createFeedbackMsg(true, data);
                        showFeedbackMsg();
                        setTimeout(function() {
                            window.location.reload();
                            return false;
                        }, 2000);
                    } else if (data.status === '401') {
                        APIUtils.redirectUserToSigninPage();
                    }
                }).catch((e) => console.log(e));
            });
        });
    }
}